<div class="sh-panel">
  @if ((hasHierarchy$ | async) && (isLoading$ | async)) {
    <sh-notification [message]="'ui.loading' | translate"></sh-notification>
  }

  @if (!(hasHierarchy$ | async) && !(isLoading$ | async) && !(loadingError$ | async)) {
    <sh-notification
      [type]="notificationType.Update"
      [message]="'hierarchy.empty.no-hierarchy' | translate"
    ></sh-notification>
  }

  @if ((loadingError$ | async) && !(isLoading$ | async)) {
    <sh-notification
      [type]="notificationType.Error"
      [message]="'hierarchy.error.failed-to-load' | translate"
      [icon]="'delete'"
    ></sh-notification>
  }

  @if ((hasHierarchy$ | async) && !(isLoading$ | async) && !(loadingError$ | async)) {
    <section>
      <h6 class="sh-clear-margin-bottom">{{ "hierarchy.parent" | translate }}</h6>
      @if (mainHierarchyItem$ | async; as main) {
        <sh-generic-list
          [rowElements]="main"
          [highlightedItem]="currentHierarchyItem$ | async"
          [actionItems]="mainHierarchyItemActions$ | async"
          [availableSelect]="false"
          [columns]="columns"
        ></sh-generic-list>
      }
      <h6>{{ "hierarchy.children" | translate }}</h6>
      <sh-generic-overview
        [columns]="columns"
        [paginatedResults]="paginatedChildHierarchyItems$ | async"
        [highlightedItem]="currentHierarchyItem$ | async"
        [actionItems]="childHierarchyItemsActions$ | async"
        [hasError]="loadingError$ | async"
        [isLoading]="isLoading$ | async"
        [showViewToggle]="false"
        [allowSort]="false"
        [searchBarMode]="searchBarMode"
        [availableSelect]="false"
        [xxResultsLabelKey]="'general.xx-results.item'"
        [noResultsLabelKey]="'general.no-results.item'"
        (paginationInfoChanged)="onChildHierarchyItemsPaginationInfoChanged($event)"
      ></sh-generic-overview>
    </section>
  }
</div>
